import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { PageMeta } from '../components/seo/PageMeta';
import { HomeBuilders } from '../components/landing/HomeBuilders';
import { HomeCatalog } from '../components/landing/HomeCatalog';
import { HomeFaq } from '../components/landing/HomeFaq';
import { LiveDashboardMock } from '../components/landing/LiveDashboardMock';

export function HomePage() {
  const { t, i18n } = useTranslation();

  const homeTitle = i18n.language?.startsWith('ar')
    ? 'شراء بروكسي | Rocket Proxy'
    : 'Buy Proxies | Residential, ISP, Mobile & Datacenter | Rocket Proxy';
  const homeDescription = i18n.language?.startsWith('ar')
    ? 'اشترِ بروكسي من Rocket Proxy: سكني، موبايل، ISP، ومركز بيانات. تسليم فوري، HTTP وSOCKS5، وحساب واحد.'
    : 'Buy proxies from Rocket Proxy. Residential, mobile, ISP, and datacenter proxies with HTTP and SOCKS5, instant delivery, and one account.';

  return (
    <div className="dx-landing">
      <PageMeta title={homeTitle} description={homeDescription} path="/" />
      <div className="dx-landing__inner">
        <section className="dx-hero-split" id="hero">
          <div className="dx-hero-split__copy">
            <h1>{t('home.hero.subtitle1')}</h1>
            <p>{t('home.hero.subtitle2')}</p>
            <div className="dx-actions">
              <Link to="/register" className="dx-btn dx-btn--primary">
                {t('home.hero.register')}
              </Link>
              <Link to="/login" className="dx-btn dx-btn--ghost">
                {t('home.hero.login')}
              </Link>
            </div>
          </div>
          <div className="dx-hero-split__visual">
            <LiveDashboardMock />
          </div>
        </section>

        <HomeCatalog />

        <HomeBuilders />

        <HomeFaq />

        <section className="dx-cta-panel" aria-labelledby="cta-heading">
          <div className="dx-cta-panel__visual" aria-hidden="true">
            <img
              className="dx-cta-panel__globe"
              src="/images/cta-globe.jpg?v=3"
              alt=""
              decoding="async"
            />
            <div className="dx-cta-panel__glow" />
          </div>
          <div className="dx-cta-panel__body">
            <h2 id="cta-heading">{t('home.cta.title')}</h2>
            <p>{t('home.cta.description')}</p>
            <Link to="/register" className="dx-btn dx-btn--primary dx-cta-panel__btn">
              {t('home.cta.getStarted')}
            </Link>
            <div className="dx-cta-panel__login">
              <small className="dx-cta-panel__login-hint">{t('home.cta.loginHint')}</small>
              <Link to="/login" className="dx-cta-panel__login-link">
                {t('home.cta.login')}
              </Link>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
